module.exports = __webpack_public_path__ + "img/lithuania.7fc1ec8d.svg";